<template>
  <section id="usersList" v-if="Object.keys(this.user).length || location_id" :class="{loading:loading}" class="my-3">
    <i v-if="loading" class="fas fa-circle-notch text-primary fa-spin loading-icon"></i>
    <div class="row">
      <div @click="clearLocation" class="col-sm-6 text-primary cursor-pointer">
        <i class="fas fa-long-arrow-alt-left ml-3 mr-2"></i>Back to locations
      </div>
      <div @click="showSendText" class="col-sm-6 text-primary cursor-pointer mb-2 mb-lg-0" v-if="users.length && location">
        <span class="float-right">
          <i class="fa fa-comment mr-2"></i>Send Text Message
        </span>
      </div>
    </div>
    <div v-if="users.length" class="content">
      <div class="d-flex px-2 head">
        <p class="col-4 col-lg-2 m-0 font-weight-bold">Name</p>
        <p class="col-4 col-lg-2 m-0 font-weight-bold">Last Payment</p>
        <p class="col-4 col-lg-2 m-0 font-weight-bold">Next Payment</p>
        <p class="col-4 col-lg-2 m-0 font-weight-bold">Balance</p>
        <p class="col-2 m-0 font-weight-bold d-none d-lg-block">Last Order</p>
        <p class="col-2 d-none d-lg-block"></p>
      </div>
      <ul class="list-group">
        <li v-for="(user, userIndex) in getUsers" :key="user.value" class="list-group-item">
          <div class="row">
            <div @click="rowClicked(user)" class="col-3 col-lg-2 text-size-small cursor-pointer lh-small d-flex align-items-center">
              <p class="m-0">{{user.label}}</p>
            </div>
            <div @click="goToPayment(user)" :class="{'cursor-pointer':user.balance > 0}" class="col-3 col-lg-2 text-size-small lh-small d-flex align-items-center">
              <span v-if="user.last_payment">
                {{ formatDollars(user.last_payment.total_amount) }} on {{ moment(user.last_payment.date).format('MM/DD/YYYY') }}
              </span>
              <span v-else>None</span>
            </div>
            <div @click="goToPayment(user)" :class="{'cursor-pointer':user.balance > 0}" 
              class="col-3 col-lg-2 text-size-small lh-small d-flex align-items-center">
              <span class="payment-current" v-if="user.balance > 0">{{nextPayment(user).format('ddd, MM/DD')}}</span>
              <span v-else>None</span>
              <i @click.self.stop="paymentReminder(user)" v-if="user.balance > 0" class="action-icon flex-center fas fa-comments-dollar"></i>
            </div>
            <div @click="goToPayment(user)" :class="{'cursor-pointer':user.balance > 0}"
              class="col-3 col-lg-2 text-size-small lh-small d-flex align-items-center">
              <p class="m-0">{{ formatDollars(user.balance) }}</p>
            </div>
            <div class="col-7 mt-3 mt-lg-0 col-lg-2 text-size-small lh-small d-flex align-items-center">
              <p class="m-0" v-if="user.last_order"><span class="d-inline d-lg-none font-weight-bold">Last Order: </span><span>{{moment(user.last_order.date).format('MM/DD/YYYY')}}</span></p>
              <span v-else>None</span>
            </div>
            <div class="col-5 col-lg-2 mt-3 mt-lg-0 flex-center justify-content-end action-links">
              <inertia-link v-if="user.balance > 0" class="flex-center text-decoration-none" title="Make payment for this user" :href="route('tu.balancepayment', user)" tabindex="-1">
                <i class="action-icon flex-center fas fa-dollar-sign"></i>
              </inertia-link>
              <!-- <i v-if="user.next_payment" title="Quick checkout" class="fas fa-shopping-cart action-icon"></i> -->
              <div @click="toDoClicked" data-toggle="collapse" role="button" aria-expanded="false" aria-controls :href="`#collapse${userIndex}`" class="d-flex">
                <i v-if="user.actions.length" title="Toggle todo list" class="action-icon fas fa-clipboard-list"></i>
              </div>
            </div>
          </div>

          <!-- Collapsable -->
          <div class="collapse" :id="`collapse${userIndex}`">
            <ul class="list-group list-group-flush mt-2">
              <template v-for="action in user.actions" :key="action.id">
                <li v-if="!Array.isArray(action)" class="list-group-item px-0">
                  <div>
                    <inertia-link :href="route(orderRoute(action.type), action.id)">
                      <i v-if="action.type === 'order'" class="fas fa-clipboard text-primary fa-lg mr-2"></i>
                      <i v-if="action.type === 'return'" class="fas fa-undo-alt text-primary fa-lg mr-2"></i>
                      <span class="font-weight-bold" v-if="action.type === 'order'">Order #{{action.id}}</span>
                      <span class="font-weight-bold" v-if="action.type === 'return'">Return #{{action.id}}</span>
                    </inertia-link>
                    <ul class="list-group list-group-flush ml-0 ml-lg-2 mt-2">
                      <li class="list-group-item py-1" v-for="product in findActionProducts(action)" :key="product.id">
                        <p class="mb-0">
                          <i class="mr-2 fas fa-truck text-primary"></i>
                          {{product.product_name}}
                          <span v-if="product.product_sku" class="text-secondary">({{product.product_sku}})</span> x {{product.qty}} - <span class="text-success">${{formatCurrency(product.costTotal)}}</span></p>
                        <span data-toggle="modal" :data-target="`#markItemDelivered${userIndex}${product.id}`" class="text-primary float-right cursor-pointer mark-delivered">Mark item delivered<i class="fas fa-long-arrow-alt-right ml-1"></i></span>
                        <jet-dialog-modal :id="`markItemDelivered${userIndex}${product.id}`">
                          <template #content>
                            <p>Are you sure you want to mark <span class="font-weight-bold">{{product.product_name}}</span> as delivered for <span class="font-weight-bold">{{user.label}}</span>?</p>
                          </template>
                          <template #footer>
                            <jet-button btnStyle="danger" data-dismiss="modal">Close</jet-button>
                            <jet-button icon="fas fa-box" data-dismiss="modal" @click="markDelivered(product, action.id)">Mark Delivered</jet-button>
                          </template>
                        </jet-dialog-modal>
                      </li>
                    </ul>
                  </div>
                </li>
              </template>
            </ul>
          </div>
        </li>
      </ul>
    </div>
    <p v-else class="m-0 mt-2 bg-grey p-2">There are no customers assigned to this location</p>
  </section>

  <jet-dialog-modal icon="fas fa-bell" id="locationTextModal" v-if="location">
    <template #title>
      Send Text to All Customers<span v-if="!textGlobal && (location.company_name || location.label)"> at {{ location.company_name || location.label }}</span>
    </template>
    <template #content>

      <div class="form-check mt-2">
        <jet-checkbox id="text_global"  class="form-check"  v-model:checked="textGlobal" />
        <jet-label for="text_global" value="Send to all customers" />
      </div>

      <div class="form-row" v-if="textShown">
        <label for="text_content">Message:</label>
        <textarea v-model="formText.content" class="form-control" v-focus id="text_content"></textarea>
      </div>
    </template>

    <template #footer>
      <jet-button icon="fas fa-paper-plane" :disable="textProcessing" @click="sendGlobalText" v-if="textGlobal">Send</jet-button>
      <jet-button icon="fas fa-paper-plane" :disable="textProcessing" @click="sendText" v-else>Send</jet-button>
      <jet-danger-button class="ml-2" @click="hideSendText">Cancel</jet-danger-button>
    </template>
  </jet-dialog-modal>
</template>

<script>
  import moment from 'moment'
  import JetDialogModal from '@/Jetstream/DialogModal'
  import JetDangerButton from '@/Jetstream/DangerButton'
  import JetCheckbox from '@/Jetstream/Checkbox'
  import JetInputError from '@/Jetstream/InputError'
  import JetLabel from '@/Jetstream/Label'

  export default {
    emits: ['clearLocation'],
    components: {
      JetDialogModal,
      JetDangerButton,
      JetCheckbox,
      JetInputError,
      JetLabel,
    },
    props: {
      users: Array,
      user: [Object, Boolean],
      location: Object,
      location_id: Number,
      loading: Boolean
    },
    data() {
      return {
        actionItems: [],
        actionItemsLoaded: false,
        filteredUsers: false,
        textProcessing: false,
        formInventory: this.$inertia.form({
          _method: 'put',
          item_id: null
        }),
        formText: this.$inertia.form({
          content: null
        }),
        textShown: false,
        textGlobal: false
      }
    },
    created() {
      this.moment = moment
    },
    mounted() {
      $('#locationTextModal').on('shown.bs.modal', () => this.textShown = true)
    },
    computed: {
      getUsers() {
        return this.filteredUsers ? this.filteredUsers : this.users
      }
    },
    methods: {
      rowClicked(user) {
        if (user) this.$inertia.get(route('tu.view', user.value))
      },
      icon(action) {
        if (action.type === 'order') return 'fas fa-truck'
        if (action.type === 'return') return 'fas fa-undo-alt'
      },
      paymentReminder(user) {
        this.$inertia.visit(route('tu.paymentreminder', user))
      },
      clearLocation() {
        this.$emit('clearLocation')
      },
      findActionProducts(action) {
        for(let i=0; i<this.actionItems.length; i++) {
          if (this.actionItems[i].id === action.id) return this.actionItems[i].info
        }
      },
      nextPayment(user) {
        let currentDate = moment().startOf('day');
        let next = currentDate.clone().startOf('week');
        next.add(user.payment_day_of_week, 'd');
        if (next.isBefore(currentDate)) {
          next.add(7, 'd');
        }

        return next;
      },
      goToPayment(user) {
        if (user.balance > 0) this.$inertia.visit(route('tu.balancepayment', user))
      },
      orderRoute(type) {
        if (type === 'order') return 'mtd.order.view'
      },
      sortUsers() {
        // Sort users by ones that have an action
        this.users.sort((a,b) => {
          if (a.actions < b.actions) return 1
          if (a.actions > b.actions) return -1
          return 0
        })
      },
      markDelivered(product, order_id) {
        this.formInventory.item_id = product.id
        this.formInventory.post(this.route('mtd.orders.markdelivered', order_id), {
          preserveState: true,
          onSuccess: () => { this.getActionItems() }
        })
      },
      paymentClass(date) {
        if (moment(date).isBefore(moment(), 'day')) return 'payment-past';
        if (moment(date).isSame(moment(), 'day')) return 'payment-current';
      },
      sortByUser() {
        this.filteredUsers = this.users.filter(elem => {
          return elem.value === this.user.value
        })
      },
      toDoClicked() {
        if (!this.actionItemsLoaded) this.getActionItems()
      },
      getActionItems() {
        this.actionItems = []
        // Populate all actions items and associate them with the action id
        this.users.forEach(user => {
          user.actions.forEach(action => {
            if (action.type == 'order') {
              axios.get(route('mtd.order.action', action.id)).then(res => {
              this.actionItems.push({
                id: action.id,
                info: res.data.items
              })
              this.actionItemsLoaded = true
            })
            }
          })
        })
      },
      showSendText() {
        this.textShown = false
        $('#locationTextModal').modal('show')
      },
      hideSendText() {
        $('#locationTextModal').modal('hide')
      },
      sendText() {
        if (!this.formText.content || this.formText.content.length == 0) return
        this.textProcessing = true

        this.formText.post(route('mtd.locationtext', this.location), {
          onSuccess: () => {
            $('#locationTextModal').modal('hide')
            this.textProcessing = false
          },
          onFinish: () => this.textProcessing = false
        })
        this.formText.reset();
      },
      sendGlobalText() {
        if (!this.formText.content || this.formText.content.length == 0) return
        this.textProcessing = true

        this.formText.post(route('mtd.globaltext'), {
          onSuccess: () => {
            $('#locationTextModal').modal('hide')
            this.textProcessing = false
          },
          onFinish: () => this.textProcessing = false
        })
        this.textGlobal = false;
        this.formText.reset();
      },
    },
    directives: {
      focus: {
        // directive definition
        mounted(el) {
          el.focus();
          el.select();
        }
      }
    },
    watch: {
      user() {
        this.user ? this.sortByUser() : this.filteredUsers = false
      }
    }
  }
</script>
